export const statName = (s: string) => {
    switch (s) {
        case "inf":
            return "Influence"
        case "lore":
            return "Lore"
        case "obs":
            return "Observation"
        case "str":
            return "Strength"
        case "will":
            return "Willpower"
        case "dmg":
            return "Damage"
        case "armr":
            return "Armor"
        case "maxHealth":
            return "Max Health"
        case "maxSanity":
            return "Max Sanity"
        default:
            return s;
    }
}